import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';

const model = {
  state: {
    companyList: [],
    rebateDetail: {}, // 返利活动信息
    opLogList: [], //操作日志列表
    logLoading: false,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { remindManage }, getState }) => ({
    async getCompanyList(value?: string) {
      if (!value || !value.replace(/\s*/g, '')) return;
      const data = await fetch('/saasmerchant/web/fscompany/getCompanyList', {
        type: 'POST',
        useJson: true,
        params: filterNull({
          auditResult: 2, // 	审核状态 1：待处理、2：通过、3：不通过 4：停用
          pageSize: 10000, // 获取全部数据，不改动后端公共接口
          parentCompanyName: value,
        }),
      });
      if (data && data.companyVos) {
        const res = data.companyVos.map((item) => ({
          companyId: item.companyId,
          companyName: item.subCompanyName,
        }));
        remindManage.setState({ companyList: res });
      }
    },
    setCompanyList(list) {
      remindManage.setState({ companyList: list });
    },
    async postRebateDetail(params) {
      const data = await fetch(
        `${
          params.awardId
            ? '/saasmerchant/web/award/updateAward'
            : '/saasmerchant/web/award/addAward'
        }`,
        {
          type: 'POST',
          params,
          useJson: true,
        },
      );
      return data;
    },
    clearRebateDetail(detail) {
      remindManage.setState({ rebateDetail: {} });
    },
    async getRebeteDetail(id: number) {
      const data = await fetch('/saasmerchant/web/award/awardDetail', {
        type: 'GET',

        params: {
          awardId: id,
        },
      });
      if (data) {
        remindManage.setState({ rebateDetail: data });
        return data;
      }
      return data;
    },
    async updateRebateStatus(params: { id: number; status: number }) {
      const data = await fetch('/saasmerchant/web/award/updateAwardStatus', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    async getRebateLog(actionId: number) {
      remindManage.setState({ logLoading: true });
      const data = await fetch('/saasmerchant/web/oplog/getOpLog', {
        type: 'GET',
        params: {
          actionId,
          type: 1,
        },
      });
      if (data) {
        remindManage.setState({ opLogList: data });
        remindManage.setState({ logLoading: false });
      }
      return data;
    },
  }),
};

export default model;
